// extracted by mini-css-extract-plugin
export var statItem = "_fh-1";
export var statsRow = "_fh-0";